export default "__VITE_ASSET__CUYqfX54__"